import React, { useEffect, useState, useRef, useContext } from "react";
import styled from "styled-components";
import { DateRangePicker } from "rsuite";
import { Input } from "rsuite";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { InputPicker } from "rsuite";
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";
import "rsuite/dist/rsuite.css";
import HospitalManageListBody from "../components/DataList/HospitalManageListBody";
import HospitalManageTitle from "../components/DataList/HospitalManageTitle";
import { useQuery } from "react-query";
import { AuthContext } from "../contexts/AuthContext";
import LoadingModal from "../components/Modal/LoadingModal";
import { useForm, Controller } from "react-hook-form";
import Footer from "../components/Footer";
import { Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logger from "../libraries/Logger";
import apiClient from "../libraries/ApiClient";
import dayjs from "dayjs";
import customStyle from "../style/HospitalAddBody.module.scss";


const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: calc(100% - 50px);
  color: #252525;
  position: relative;
  h1 {
    line-height: 20px;
  }
  .search {
    width: 100%;
    .searchTop {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      position: relative;
      .left {
        width: 100%;
        display: flex;
        .Condition {
          width: 25%;
          @media screen and (max-width: 575px) {
            width: 60%;
          }
        }
        .otherCondition {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border: 1px solid #f2f2f2;
          border-radius: 5px;
          font-size: 14px;
          cursor: pointer;
          margin-left: 16px;
        }
      }
    }
    .searchBottom {
      border: 1px solid #f2f2f2;
      width: 100%;
      padding: 8px;
      margin-bottom: 8px;
      border-radius: 5px;
      display: ${({ isOpen }) => (isOpen ? `flex` : `none`)};
      /* position: absolute; */
      z-index: 1;
      flex-direction: column;
      .top {
        display: flex;
        justify-content: space-between;
        .basicInformation {
          width: 49%;
        }
        .caseStatus {
          width: 49%;
        }
      }
      .btn {
        display: flex;
        justify-content: end;
      }
    }
  }
  .pagination {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    position: ${({ isOpen }) => (isOpen ? `initial` : `absolute`)};
    bottom: 0px;
  }
  .table {
    width: 100%;
    max-height: calc(100% - 246px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

const predefinedBottomRanges = [
  {
    label: "今天",
    value: [new Date(), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "昨天",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "近7日",
    value: [subDays(new Date(), 6), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "近30日",
    value: [subDays(new Date(), 29), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "本月",
    value: [startOfMonth(new Date()), new Date()],
    closeOverlay: false,
    appearance: "default",
  },
  {
    label: "上月",
    value: [
      startOfMonth(addMonths(new Date(), -1)),
      endOfMonth(addMonths(new Date(), -1)),
    ],
    closeOverlay: false,
    appearance: "default",
  },
];

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
});

const CssSaveButton = style(Button)({
  fontSize: 12,
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",

  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function HospitalManageList({ lineUserId }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  const permission = myAuth.AccountPermission;
  const [selfIdentities, setSelfIdentities] = useState([]);
  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
    // if (!isAdmin) {
    //   alert("您無此權限，為您轉到轉診清單頁");
    //   navigate("/ReferralDataList");
    // }

    if (permission != 1) {
      alert("您無此權限，為您轉到轉診清單頁");
      navigate("/ReferralDataList");
    }

    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    if (token === undefined) {
      navigate("/Login");
    }

    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);

  const { getValues, control, reset } = useForm({
    defaultValues: {
      hospitalCode: "",
      hospitalName: "",
      status: 0,
      open: false,
    },
  });

  const [open, setOpen] = useState(false);
  const [token, setToken] = useState("");
  const [nowPageNumber, setNowPageNumber] = useState(1);
  const [sortData, setSortData] = useState({ Column: "", Direction: "" });

  const handlePageChange = (event, value) => {
    setNowPageNumber(value);
  };

  const handleSortChange = (column, direction) => {
    // console.log("ListhandleSortChange");
    setSortData({ Column: column, Direction: direction });
    setNowPageNumber(1);
  };

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    if (JSON.parse(localStorage.getItem("auth")) === null || token === null) {
      navigate("/Login");
    }
  }, []);

  const sendSearchData = async ({ queryKey }) => {
    const data = {
      Data: {
        CurrentPage: queryKey[2],
        PageSize: 15,
        Status: queryKey[5],
        OrgCode: queryKey[3],
        OrgName: queryKey[4],
        SortColumn: queryKey[6],
        SortDirection: queryKey[7],
      },
    };

    const result = await apiClient.postAes(
      "api/Organization/List/Security",
      data
    );
    if (result?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
    }

    return result?.data;   
  };

  const { data, refetch, isLoading } = useQuery(
    [
      "sendSearchData",
      token,
      nowPageNumber,
      getValues("hospitalCode"),
      getValues("hospitalName"),
      getValues("status"),
      sortData.Column,
      sortData.Direction,
    ],
    sendSearchData,
    { refetchOnWindowFocus: false, enabled: !!token }
  );
  // console.log(data);

  // const getHospitalData = async ({ queryKey }) => {
  //   const data = {
  //     Data: {},
  //   };
  //   //const result = await apiClient.post("api/referral/GetOrg", token, data);
  //   const result = await apiClient.postAes(
  //     "api/referral/GetOrg/Security",
  //     data
  //   );
  //   return result?.data;
  // };

  // const { data: hospitalData } = useQuery(
  //   ["getHospitalData", token],
  //   getHospitalData,
  //   {
  //     enabled: !!token,
  //     refetchOnWindowFocus: false,
  //   }
  // );

  const StatusData = [
    { label: "All", value: 0 },
    { label: "啟用", value: 1 },
    { label: "停用", value: 2 },
  ].map((item) => ({ label: item.label, value: item.value }));

 
  const OverLimit = data?.Data?.ExceedLimit;

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <Container isOpen={open}>
      <LoadingModal isOpen={isLoading} />
      <HospitalManageTitle data={OverLimit} />
      <div className="search">
        <div className="searchTop">
          <div className="left">
            <div className="Condition">
            <Controller
                control={control}
                name="hospitalName"
                render={({ field: { value, onChange } }) => (
                  <Input
                    placeholder="請輸入機構中文名稱"
                    value={value}
                    onChange={onChange}
                    onBlur={() => {
                      refetch();
                      setNowPageNumber(1);
                    }}
                  />
                )}
              />              
            </div>
            <div
              className="otherCondition"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <i
                className="fa-solid fa-filter"
                style={{ fontSize: "12px" }}
              ></i>
              其他條件
              <i
                className="fa-solid fa-chevron-down"
                style={{ fontSize: "12px" }}
              ></i>
            </div>
          </div>
        </div>
        <div className="searchBottom">
          <div className="top">
            <div className="basicInformation">
              <h1 style={{ padding: "4px" }}>機構代碼</h1>
              <Controller
                control={control}
                name="hospitalCode"
                render={({ field: { value, onChange } }) => (
                  <Input
                    placeholder="請輸入機構代碼"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </div>
            <div className="caseStatus">
              <h1 style={{ padding: "4px" }}>狀態</h1>
              <Controller
                control={control}
                name="status"
                render={({ field: { value, onChange } }) => (
                  <InputPicker
                    className={customStyle.status}
                    placeholder="請選擇狀態"
                    data={StatusData}
                    // className={customStyle.status}
                    value={value}
                    onChange={onChange}
                    searchable={false}
                    cleanable={false}
                  />
                )}
              />
            </div>
          </div>
          <div className="btn">
            <CssCancelButton
              size="small"
              variant="outlined"
              style={{ minWidth: "70px", margin: "8px 8px 0px 8px" }}
              onClick={() => {
                reset();
              }}
            >
              重設
            </CssCancelButton>
            <CssSaveButton
              size="small"
              variant="contained"
              style={{ minWidth: "70px", margin: "8px 8px 0px 8px" }}
              onClick={() => {
                refetch();
                setNowPageNumber(1);
              }}
            >
              確認
            </CssSaveButton>
          </div>
        </div>
      </div>
      <div className="table">
        <HospitalManageListBody
          data={data?.Data}
          column={sortData.Column}
          direction={sortData.Direction}
          onSort={handleSortChange}
        />
      </div>
      <div className="pagination">
        <Pagination
          count={data?.Data.PageCount}
          showFirstButton
          showLastButton
          page={nowPageNumber}
          onChange={handlePageChange}
          siblingCount={0}
          boundaryCount={2}
          style={{ padding: "8px 0px" }}
        />
        <Footer />
      </div>
    </Container>
  );
}

export default HospitalManageList;
